const { default: Conditional } = require('decorators/conditional');
const { default: ScrollPage } = require('@sp/ui/v2/pages/ScrollPage');
const { default: Mobile } = require('./index.mobile');

export default Conditional({
  default: ScrollPage,
  mobile: Mobile,
});
